<script>
import store from '@/store';
import {GameLauncher} from '@/mixins/game-launcher';

export default {
  name: 'GameError',

  metaInfo: {
    title: 'GameError',
  },

  mixins: [GameLauncher],

  data() {
    return {
      maxBlastChampsBanner: '/images/gamesErrorPage/max-blast-champs-bg.jpg',
      maxBlastChampsLogo: '/images/gamesErrorPage/max-blast-champs-logo.png',
      sectorXBanner: '/images/gamesErrorPage/sectorx_bg.jpg',
      sectorXLogo: '/images/gamesErrorPage/sectorx-logo.png',
      dragonstoneBanner: '/images/gamesErrorPage/ds-bg.jpg',
      dragonstoneLogo: '/images/gamesErrorPage/ds-logo.png',
      missionAmazonBanner: '/images/gamesErrorPage/amazon-bg.jpg',
      missionAmazonLogo: '/images/gamesErrorPage/amazon-logo.png',
      tripleMaxBlastBanner: '/images/gamesErrorPage/triple-max-blast-bg.jpg',
      tripleMaxBlastLogo: '/images/gamesErrorPage/triple-max-blast-logo.png',
      tripleCashOrCrashBanner: '/images/gamesErrorPage/triple-cash-crash-bg.jpg',
      tripleCashOrCrashLogo: '/images/gamesErrorPage/triple-cash-crash-logo.png',
      emptyColorFill: {
        radial: true,
        colors: [
          {
            color: '#ce952e',
            offset: '50',
            opacity: '0.2',
          },
          {
            color: '#ce952e',
            offset: '50',
            opacity: '0.15',
          },
          {
            color: '#ce952e',
            offset: '70',
            opacity: '0.15',
          },
          {
            color: '#ce952e',
            offset: '70',
            opacity: '0.1',
          },
          {
            color: '#ce952e',
            offset: '90',
            opacity: '0.1',
          },
          {
            color: 'transparent',
            offset: '90',
            opacity: '0.1',
          },
          {
            color: 'transparent',
            offset: '95',
            opacity: '0.1',
          },
          {
            color: 'transparent',
            offset: '95',
            opacity: '0.1',
          },
        ],
      },
      progdata: [
        {
          progress: 50, // required for each circle
          color: '#ce952e', // will overwrite global progress color
        },
      ],
      gradient: {
        radial: false,
        colors: [
          {
            color: '#ce952e',
            offset: 0,
            opacity: '1',
          },
          {
            color: 'black',
            offset: 100,
            opacity: '0.6',
          },
        ],
      },
      gameId: '',
      gameURL: ''
    };
  },

  computed: {
    userSignedIn() {
      return !!store.getters.getuser;
    },
    loading() {
      return store.getters.getloading;
    },
    backgroundImage() {
      const gameId = this.$route.query.gameId;

      switch (gameId) {
        case '838':
        case '856':
          return [this.dragonstoneBanner, this.dragonstoneLogo];
        case '859':
        case '862':
          return [this.missionAmazonBanner, this.missionAmazonLogo];
        case '863':
          return [this.tripleCashOrCrashBanner, this.tripleCashOrCrashLogo];
        case '875':
          return [this.tripleMaxBlastBanner, this.tripleMaxBlastLogo];
        case '864':
          return [this.maxBlastChampsBanner, this.maxBlastChampsLogo];
        case '866':
        case '867':
          return [this.sectorXBanner, this.sectorXLogo];
        default:
          return '';
      }
    },
  },

  created() {
    if (this.$route.query.incompleteRoundUrl && this.$route.query.gameId) {
      this.gameURL = this.$route.query.incompleteRoundUrl;
      this.gameId = this.$route.query.gameId;
    }
  },
};
</script>

<template>
  <div class="pt-0 h-full">
    <div v-if="loading" class="d-flex justify-center align-center h-full">
      <vue-ellipse-progress
        :data="progdata"
        :empty-color-fill="emptyColorFill"
        :empty-thickness="3"
        :gradient="gradient"
        :legend="false"
        :loading="true"
        :progress="100"
        :size="350"
        :thickness="7"
        animation="rs 700 1000"
        dash="strict 60 0.8"
        empty-color="grey"
        font-size="1.5rem"
        line-mode="out 5"
      >
        <v-icon slot="legend-caption" color="#F8BF1E" size="46">
          mdi-sword-cross
        </v-icon>
      </vue-ellipse-progress>
    </div>

    <v-row v-if="!loading" :style="{ backgroundImage: `url(${backgroundImage[0]})` }"
           class="d-flex justify-center align-center h-full gameBackground">
      <v-col class="text-center" cols="12">
        <v-img
          :src="backgroundImage[1]"
          contain
          justify="left"
          max-height="300"
        />
        <div v-if="gameURL" class="message-wrapper">
          <h1>You already have an open game session which needs to be completed. <br/> Please resume the game
          </h1>
          <v-btn
            class="border-doubled gold large black--text"
            @click="relaunchGame(gameId, gameURL)"
          >
            Resume Game
          </v-btn>
        </div>
        <div v-else class="message-wrapper">
          <h1>Thank you for playing. Please try again later.</h1>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<style lang="scss" scoped>
.gameBackground {
  background-position: center;
  background-size: cover;
  position: relative;
}

.message-wrapper {
  max-width: 900px;
  background-color: rgba(0, 0, 0, 0.8);
  border-radius: 20px;
  margin: 60px auto;
  text-align: center;
  padding: 20px;
  width: 100%;
  display: block;

  h1 {
    font-family: 'Barlow', arial, sans-serif;
    font-weight: 400;
    color: #ffffff;
    font-size: 1.8em;
  }
}

.loader {
  display: none !important;
  z-index: 0 !important;
}

button.gold {
  background-color: #f8bf1e !important;
}
</style>
